import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {ProductCategoryAttribute} from '../../master-data/master-data.model';
import {ProductCategoriesAttributes} from '../../../locale/consts.en';

@Component({
    selector: 'app-product-categories-attribute-edit',
    templateUrl: './product-categories-attribute-edit.component.html',
    styleUrls: ['./product-categories-attribute-edit.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductCategoriesAttributeEditComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<ProductCategoriesAttributeEditComponent>>(MatDialogRef);


  form: FormGroup;
  ProductCategoriesAtt = ProductCategoriesAttributes;


  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: [null, [Validators.required]],
      key: [null, [Validators.required]],
      sort: [0],
      productAttributeType: [null, [Validators.required]]
    });
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onSave() {
    const prodAttrib = new ProductCategoryAttribute(
      this.form.controls.name.value,
      this.form.controls.key.value,
      this.form.controls.sort.value ?? 0,
      this.form.controls.productAttributeType.value,
    );

    this.dialogRef.close(prodAttrib);
  }
}
